export const APP_SETTINGS = {
  tokenDecimals: 18,
  telegramUrl: 'https://t.me/+D97nk4y54sNiOGM1',
  comingSoonLaunchAtIso: '2026-08-07T15:30:00Z',
} as const;
